import React from 'react';
import { isMobile } from 'react-device-detect';
import logo from '../../../assets/logo.png';
import { faList } from '@fortawesome/free-solid-svg-icons';
import { useAuth } from '../../../contexts/AuthContext';
import { SeparationType } from '../../../enums/SeparationType';
import { Breadcrumb, IBreadcrumbItem } from '../../Breadcrumb/Breadcrumb';
import { DropdownButton } from '../../DropdownButton/DropdownButton';
import { Container, Left, Right, Logo, PageInfo, PageTitle } from './styles';
import { Button } from '../../Button/Button';
import { ReportJobQueueListModal } from '../../../components/ReportJobQueueListModal/ReportJobQueueListModal';
import { ProfileType } from '../../../enums/ProfileType';

interface IHeaderProps {
  title: string;
  rightContent?: React.ReactNode;
  userMenu?: boolean;
  breadcrumbItems?: IBreadcrumbItem[];
  separationType?: SeparationType;
  version?: number;
  alertSummary?: boolean;
  reportList?: boolean;
}

export const Header: React.FC<IHeaderProps> = ({
  title,
  rightContent,
  userMenu = true,
  breadcrumbItems,
  separationType,
  version,
  alertSummary,
  reportList
}) => {

  const { session, signOut } = useAuth();
  const [showReportJobQueueListModal, setShowReportJobQueueListModal] = React.useState(false);

  const memoMenuRender = React.useMemo(() => {
    if (!userMenu) return null;
    return (
      <>
        {reportList && (session?.user?.profileType == ProfileType.Admin || session?.user?.profileType == ProfileType.Ecommerce) ? (
          <Button icon={faList} type='secondary' title='Relatórios' click={() => setShowReportJobQueueListModal(true)} />
        ) : null}
        <DropdownButton
          text={session?.user?.name || 'Usuário'}
          items={[{ text: 'Sair', key: 'signOut' }]}
          clickItem={() => signOut()}
          small={isMobile}
        />
      </>
    )
  }, [userMenu, separationType, version, reportList]);

  return (
    <Container>
      <Left>
        <Logo src={logo} alt='Logo Zerezes' />
        <PageInfo>
          <Breadcrumb items={breadcrumbItems} />
          <PageTitle>{title}</PageTitle>
        </PageInfo>
      </Left>
      <Right>
        {rightContent}
        {memoMenuRender}
      </Right>
      {showReportJobQueueListModal && (
        <ReportJobQueueListModal
          visible={true}
          onClose={() => setShowReportJobQueueListModal(false)}
        />
      )}
    </Container>
  );
}